import React from "react";

export default function PricingIcon() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.67408 1.5845L2.09908 3.141C1.85941 3.24742 1.67112 3.44373 1.57479 3.68763C1.47846 3.93154 1.4818 4.20353 1.58408 4.445L4.04408 10.3925C4.09314 10.5133 4.16581 10.623 4.25782 10.7154C4.34983 10.8077 4.45934 10.8808 4.57993 10.9303C4.70053 10.9798 4.82979 11.0047 4.96014 11.0036C5.0905 11.0026 5.21932 10.9755 5.33908 10.924L8.91008 9.369C9.15067 9.26314 9.33991 9.06681 9.43685 8.8225C9.53379 8.57818 9.53064 8.30551 9.42808 8.0635L6.96808 2.1165C6.91906 1.99581 6.84647 1.88609 6.75456 1.79378C6.66264 1.70147 6.55324 1.62841 6.43275 1.57888C6.31227 1.52935 6.18312 1.50433 6.05285 1.50529C5.92259 1.50626 5.79382 1.53319 5.67408 1.5845ZM8.50008 1.5C8.75237 1.49992 8.99537 1.5952 9.18036 1.76675C9.36535 1.93829 9.47866 2.17342 9.49758 2.425L9.50008 2.5V4.25C9.49994 4.37744 9.45114 4.50002 9.36366 4.59268C9.27618 4.68535 9.15661 4.74112 9.02939 4.74859C8.90217 4.75605 8.77689 4.71466 8.67917 4.63287C8.58144 4.55107 8.51864 4.43505 8.50358 4.3085L8.50008 4.25V2.5H8.00008C7.87264 2.49986 7.75007 2.45106 7.6574 2.36358C7.56473 2.27609 7.50897 2.15652 7.5015 2.0293C7.49403 1.90208 7.53542 1.77681 7.61722 1.67908C7.69901 1.58136 7.81504 1.51855 7.94158 1.5035L8.00008 1.5H8.50008ZM10.0401 2.805C10.0919 2.68307 10.1899 2.58667 10.3128 2.53699C10.4356 2.4873 10.5731 2.48839 10.6951 2.54C10.8236 2.594 10.9476 2.645 11.0796 2.697C11.3115 2.79545 11.4977 2.9778 11.601 3.20761C11.7042 3.43741 11.717 3.69772 11.6366 3.9365L11.6086 4.0095L10.4596 6.6965C10.409 6.81312 10.3159 6.90611 10.1993 6.95655C10.0826 7.007 9.9511 7.01112 9.8315 6.96807C9.7119 6.92502 9.61319 6.83803 9.55543 6.7248C9.49768 6.61157 9.48522 6.48059 9.52058 6.3585L9.54058 6.3035L10.6886 3.618L10.5056 3.544L10.3046 3.4605C10.2441 3.43486 10.1892 3.39754 10.1432 3.35068C10.0971 3.30383 10.0607 3.24835 10.0361 3.18743C10.0115 3.1265 9.99914 3.06132 9.99974 2.99562C10.0003 2.92991 10.0139 2.86497 10.0396 2.8045L10.0401 2.805Z"
        fill="url(#paint0_linear_247_365)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_247_365"
          x1="13.0721"
          y1="1.36651"
          x2="1.35398"
          y2="13.3516"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#35D7E4" />
          <stop offset="1" stopColor="#0A829D" />
        </linearGradient>
      </defs>
    </svg>
  );
}
